import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { fetchCampaignList } from '../../../api/campaign.api';
import CampaignCard from '../../../components/campaign/card';
import React from 'react';
import { ICampaignList } from '../../../types/campaign.types';

const ActiveCampaigns: React.FC = () => {
  // const params = useParams(); // Not used currently
  const params = useParams<{ id: string }>();

  const entity_id = params.id || '';
  const page = 1;
  const limit = 5;

  const { data, isLoading, isError } = useQuery({
    queryKey: ['campaigns', entity_id, page, limit],
    queryFn: () => fetchCampaignList({ entity_id, page, limit })
  });

  if (isLoading) return <div>Loading campaigns...</div>;
  if (isError || !data?.success) return <div>No active campaigns found.</div>;

  return (
    <div className="mx-auto flex max-w-[calc(100%_-_2rem)] flex-wrap">
      {data?.data?.map((campaign: ICampaignList) => (
        <Link
          to={`${campaign.campaign_id}`}
          className="basis-1/2 p-2 sm:basis-1/3 md:basis-1/5 lg:basis-1/5"
          key={campaign.campaign_id}
        >
          <CampaignCard
            campaign={{
              campaignId: campaign.campaign_id,
              campaignImageUrl: campaign.portal_image,
              title: campaign.campaign_name,
              description: campaign.campaign_description
            }}
          />
        </Link>
      ))}
    </div>
  );
};

export default ActiveCampaigns;
